import { useTranslation } from 'react-i18next'
import Toggle from './Toggle'
import { Text } from './typography'
import { track } from '~/analytics'

export default function LanguageSelect() {
  const { t, i18n } = useTranslation()

  return (
    <div className="flex flex-col items-start gap-2 rounded-xl bg-neutral-white px-4 py-2">
      <Text level={1} className="text-neutral-midfi-grey">
        {t('common.language')}
      </Text>
      <Toggle
        left={t('common.en')}
        right={t('common.es')}
        checked={i18n.language === 'es'}
        onChange={(enabled) => {
          const language = enabled ? 'es' : 'en'
          i18n.changeLanguage(language)
          track('language_selected', { language })
        }}
      />
    </div>
  )
}
